import * as type from './constant';

export const getMember = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getMemberSuccess = (payload, selfRole = '') => ({
  type: type.GET_SUCCESS,
  payload,
  selfRole,
});

export const getMemberError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addMember = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addMemberSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateMember = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateMemberSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteMember = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteMemberSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const updateMemberSelf = (id, payload) => ({
  type: type.UPDATE_SELF,
  id,
  payload,
});

export const updateMemberSelfSuccess = (payload) => ({
  type: type.UPDATE_SELF_SUCCESS,
  payload,
});

export const manipulationMemberError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});

export const getMemberOverview = (id, params = undefined, selfRole = undefined) => ({
  type: type.GET_OVERVIEW,
  id,
  params,
  selfRole,
});

export const getMemberOverviewSuccess = (payload, selfRole = '') => ({
  type: type.GET_OVERVIEW_SUCCESS,
  payload,
  selfRole,
});